export interface AnreMonthlyInputState {
  canSubmit: boolean;
  submitTitle: string | undefined;
  warning: string | null;
}

export function anreMonthlyInputState({
  hasTemplate,
  hasBrmda,
  hasBrmid,
  filling,
}: {
  hasTemplate: boolean;
  hasBrmda: boolean;
  hasBrmid: boolean;
  filling: boolean;
}): AnreMonthlyInputState {
  const hasCentralizer = hasBrmda || hasBrmid;
  const missingMarket = hasBrmda === hasBrmid ? null : hasBrmda ? "BRMID" : "BRMDA";
  const warning = missingMarket
    ? `${missingMarket} centralizer is not uploaded. Its ANRE rows will be filled with zero; generation can continue.`
    : null;

  return {
    canSubmit: hasTemplate && hasCentralizer && !filling,
    submitTitle: !hasTemplate
      ? "Upload an ANRE template once; after that it is optional."
      : !hasCentralizer
      ? "Upload at least one BRMDA or BRMID centralizer."
      : warning ?? undefined,
    warning,
  };
}
